import React from "react";
import { PortfolioElementType } from "types/PortfolioTypes";
import styles from "./portfolioCompareTableBar.module.scss";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import FinecoTableCompare from "./FinecoTableCompare";
import PortfolioCompareChart from "./PortfolioCompareChart";
type Props = {
  dataItem: PortfolioElementType;
  dataItem2: PortfolioElementType;
  subSection?: boolean;
};
const PortfolioCompareTableBar: React.FC<Props> = ({
  dataItem,
  dataItem2,
  subSection,
}) => {
  const portfolio1Data = dataItem.data;
  const portfolio2Data = dataItem2.data;
  return (
    <>
      {!subSection && (
        <h3 className={commonStyles.titleChart}>{dataItem.configData.label}</h3>
      )}
      {subSection && (
        <div className={commonStyles.subtitleChart}>
          {/* {dataItem.configData.label} */}
        </div>
      )}
      <div className={styles.portfolioDistribution}>
        <FinecoTableCompare dataObject={dataItem} dataObject2={dataItem2} />
        <PortfolioCompareChart data1={portfolio1Data} data2={portfolio2Data} />
      </div>
    </>
  );
};

export default PortfolioCompareTableBar;
